var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
import { decodeUTF8 } from '@zenfs/core';
import { deserialize, sizeof, struct, types as t } from 'utilium';
import { SLComponentRecord } from './SLComponentRecord.js';
import { LongFormDate, ShortFormDate } from './utils.js';
/**
 * Note, GNU ISO is used for reference.
 * @see https://git.savannah.gnu.org/cgit/libcdio.git/tree/include/cdio/rock.h
 */
/**
 * Base system use entry
 */
let SystemUseEntry = (() => {
    var _a, _b, _c;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _signature_decorators;
    let _signature_initializers = [];
    let _signature_extraInitializers = [];
    let _length_decorators;
    let _length_initializers = [];
    let _length_extraInitializers = [];
    let _suVersion_decorators;
    let _suVersion_initializers = [];
    let _suVersion_extraInitializers = [];
    var SystemUseEntry = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            _signature_decorators = [(_a = t).uint16.bind(_a)];
            _length_decorators = [(_b = t).uint8.bind(_b)];
            _suVersion_decorators = [(_c = t).uint8.bind(_c)];
            __esDecorate(null, null, _signature_decorators, { kind: "field", name: "signature", static: false, private: false, access: { has: obj => "signature" in obj, get: obj => obj.signature, set: (obj, value) => { obj.signature = value; } }, metadata: _metadata }, _signature_initializers, _signature_extraInitializers);
            __esDecorate(null, null, _length_decorators, { kind: "field", name: "length", static: false, private: false, access: { has: obj => "length" in obj, get: obj => obj.length, set: (obj, value) => { obj.length = value; } }, metadata: _metadata }, _length_initializers, _length_extraInitializers);
            __esDecorate(null, null, _suVersion_decorators, { kind: "field", name: "suVersion", static: false, private: false, access: { has: obj => "suVersion" in obj, get: obj => obj.suVersion, set: (obj, value) => { obj.suVersion = value; } }, metadata: _metadata }, _suVersion_initializers, _suVersion_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            SystemUseEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        data;
        constructor(data) {
            __runInitializers(this, _suVersion_extraInitializers);
            this.data = data;
            deserialize(this, data);
        }
        signature = __runInitializers(this, _signature_initializers, void 0);
        get signatureString() {
            return decodeUTF8(this.data.slice(0, 2));
        }
        length = (__runInitializers(this, _signature_extraInitializers), __runInitializers(this, _length_initializers, void 0));
        suVersion = (__runInitializers(this, _length_extraInitializers), __runInitializers(this, _suVersion_initializers, void 0));
    };
    return SystemUseEntry = _classThis;
})();
export { SystemUseEntry };
/**
 * Continuation entry.
 */
let CEEntry = (() => {
    var _a, _b, _c;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _extent_decorators;
    let _extent_initializers = [];
    let _extent_extraInitializers = [];
    let _offset_decorators;
    let _offset_initializers = [];
    let _offset_extraInitializers = [];
    let _size_decorators;
    let _size_initializers = [];
    let _size_extraInitializers = [];
    var CEEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _extent_decorators = [(_a = t).uint64.bind(_a)];
            _offset_decorators = [(_b = t).uint64.bind(_b)];
            _size_decorators = [(_c = t).uint64.bind(_c)];
            __esDecorate(null, null, _extent_decorators, { kind: "field", name: "extent", static: false, private: false, access: { has: obj => "extent" in obj, get: obj => obj.extent, set: (obj, value) => { obj.extent = value; } }, metadata: _metadata }, _extent_initializers, _extent_extraInitializers);
            __esDecorate(null, null, _offset_decorators, { kind: "field", name: "offset", static: false, private: false, access: { has: obj => "offset" in obj, get: obj => obj.offset, set: (obj, value) => { obj.offset = value; } }, metadata: _metadata }, _offset_initializers, _offset_extraInitializers);
            __esDecorate(null, null, _size_decorators, { kind: "field", name: "size", static: false, private: false, access: { has: obj => "size" in obj, get: obj => obj.size, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, _size_initializers, _size_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            CEEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        _entries = [];
        /**
         * Logical block address of the continuation area.
         */
        extent = __runInitializers(this, _extent_initializers, void 0);
        /**
         * Offset into the logical block.
         */
        offset = (__runInitializers(this, _extent_extraInitializers), __runInitializers(this, _offset_initializers, void 0));
        /**
         * Length of the continuation area.
         */
        size = (__runInitializers(this, _offset_extraInitializers), __runInitializers(this, _size_initializers, void 0));
        entries(data) {
            this._entries ||= constructSystemUseEntries(data, Number(this.extent * 2048n + this.offset), this.size, data);
            return this._entries;
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _size_extraInitializers);
        }
    };
    return CEEntry = _classThis;
})();
export { CEEntry };
/**
 * Padding entry.
 */
let PDEntry = (() => {
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    var PDEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            PDEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
    };
    return PDEntry = _classThis;
})();
export { PDEntry };
/**
 * Identifies that SUSP is in-use.
 */
let SPEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _magic_decorators;
    let _magic_initializers = [];
    let _magic_extraInitializers = [];
    let _skip_decorators;
    let _skip_initializers = [];
    let _skip_extraInitializers = [];
    var SPEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _magic_decorators = [t.uint8(2)];
            _skip_decorators = [(_a = t).uint8.bind(_a)];
            __esDecorate(null, null, _magic_decorators, { kind: "field", name: "magic", static: false, private: false, access: { has: obj => "magic" in obj, get: obj => obj.magic, set: (obj, value) => { obj.magic = value; } }, metadata: _metadata }, _magic_initializers, _magic_extraInitializers);
            __esDecorate(null, null, _skip_decorators, { kind: "field", name: "skip", static: false, private: false, access: { has: obj => "skip" in obj, get: obj => obj.skip, set: (obj, value) => { obj.skip = value; } }, metadata: _metadata }, _skip_initializers, _skip_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            SPEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        magic = __runInitializers(this, _magic_initializers, void 0);
        checkMagic() {
            return this.magic[0] == 190 && this.magic[1] == 239;
        }
        skip = (__runInitializers(this, _magic_extraInitializers), __runInitializers(this, _skip_initializers, void 0));
        constructor() {
            super(...arguments);
            __runInitializers(this, _skip_extraInitializers);
        }
    };
    return SPEntry = _classThis;
})();
export { SPEntry };
/**
 * Identifies the end of the SUSP entries.
 */
let STEntry = (() => {
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    var STEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            STEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
    };
    return STEntry = _classThis;
})();
export { STEntry };
/**
 * Specifies system-specific extensions to SUSP.
 */
let EREntry = (() => {
    var _a, _b, _c, _d;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _idLength_decorators;
    let _idLength_initializers = [];
    let _idLength_extraInitializers = [];
    let _descriptorLength_decorators;
    let _descriptorLength_initializers = [];
    let _descriptorLength_extraInitializers = [];
    let _sourceLength_decorators;
    let _sourceLength_initializers = [];
    let _sourceLength_extraInitializers = [];
    let _extensionVersion_decorators;
    let _extensionVersion_initializers = [];
    let _extensionVersion_extraInitializers = [];
    var EREntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _idLength_decorators = [(_a = t).uint8.bind(_a)];
            _descriptorLength_decorators = [(_b = t).uint8.bind(_b)];
            _sourceLength_decorators = [(_c = t).uint8.bind(_c)];
            _extensionVersion_decorators = [(_d = t).uint8.bind(_d)];
            __esDecorate(null, null, _idLength_decorators, { kind: "field", name: "idLength", static: false, private: false, access: { has: obj => "idLength" in obj, get: obj => obj.idLength, set: (obj, value) => { obj.idLength = value; } }, metadata: _metadata }, _idLength_initializers, _idLength_extraInitializers);
            __esDecorate(null, null, _descriptorLength_decorators, { kind: "field", name: "descriptorLength", static: false, private: false, access: { has: obj => "descriptorLength" in obj, get: obj => obj.descriptorLength, set: (obj, value) => { obj.descriptorLength = value; } }, metadata: _metadata }, _descriptorLength_initializers, _descriptorLength_extraInitializers);
            __esDecorate(null, null, _sourceLength_decorators, { kind: "field", name: "sourceLength", static: false, private: false, access: { has: obj => "sourceLength" in obj, get: obj => obj.sourceLength, set: (obj, value) => { obj.sourceLength = value; } }, metadata: _metadata }, _sourceLength_initializers, _sourceLength_extraInitializers);
            __esDecorate(null, null, _extensionVersion_decorators, { kind: "field", name: "extensionVersion", static: false, private: false, access: { has: obj => "extensionVersion" in obj, get: obj => obj.extensionVersion, set: (obj, value) => { obj.extensionVersion = value; } }, metadata: _metadata }, _extensionVersion_initializers, _extensionVersion_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            EREntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        idLength = __runInitializers(this, _idLength_initializers, void 0);
        descriptorLength = (__runInitializers(this, _idLength_extraInitializers), __runInitializers(this, _descriptorLength_initializers, void 0));
        sourceLength = (__runInitializers(this, _descriptorLength_extraInitializers), __runInitializers(this, _sourceLength_initializers, void 0));
        extensionVersion = (__runInitializers(this, _sourceLength_extraInitializers), __runInitializers(this, _extensionVersion_initializers, void 0));
        get extensionIdentifier() {
            return decodeUTF8(this.data.slice(8, 8 + this.idLength));
        }
        get extensionDescriptor() {
            return decodeUTF8(this.data.slice(8 + this.idLength, 8 + this.idLength + this.descriptorLength));
        }
        get extensionSource() {
            const start = 8 + this.idLength + this.descriptorLength;
            return decodeUTF8(this.data.slice(start, start + this.sourceLength));
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _extensionVersion_extraInitializers);
        }
    };
    return EREntry = _classThis;
})();
export { EREntry };
let ESEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _extensionSequence_decorators;
    let _extensionSequence_initializers = [];
    let _extensionSequence_extraInitializers = [];
    var ESEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _extensionSequence_decorators = [(_a = t).uint8.bind(_a)];
            __esDecorate(null, null, _extensionSequence_decorators, { kind: "field", name: "extensionSequence", static: false, private: false, access: { has: obj => "extensionSequence" in obj, get: obj => obj.extensionSequence, set: (obj, value) => { obj.extensionSequence = value; } }, metadata: _metadata }, _extensionSequence_initializers, _extensionSequence_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            ESEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        extensionSequence = __runInitializers(this, _extensionSequence_initializers, void 0);
        constructor() {
            super(...arguments);
            __runInitializers(this, _extensionSequence_extraInitializers);
        }
    };
    return ESEntry = _classThis;
})();
export { ESEntry };
/**
 * RockRidge: Marks that RockRidge is in use
 * @deprecated
 */
let RREntry = (() => {
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    var RREntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            RREntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
    };
    return RREntry = _classThis;
})();
export { RREntry };
/**
 * RockRidge: Records POSIX file attributes.
 */
let PXEntry = (() => {
    var _a, _b, _c, _d, _e;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _mode_decorators;
    let _mode_initializers = [];
    let _mode_extraInitializers = [];
    let _nlinks_decorators;
    let _nlinks_initializers = [];
    let _nlinks_extraInitializers = [];
    let _uid_decorators;
    let _uid_initializers = [];
    let _uid_extraInitializers = [];
    let _gid_decorators;
    let _gid_initializers = [];
    let _gid_extraInitializers = [];
    let _inode_decorators;
    let _inode_initializers = [];
    let _inode_extraInitializers = [];
    var PXEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _mode_decorators = [(_a = t).uint64.bind(_a)];
            _nlinks_decorators = [(_b = t).uint64.bind(_b)];
            _uid_decorators = [(_c = t).uint64.bind(_c)];
            _gid_decorators = [(_d = t).uint64.bind(_d)];
            _inode_decorators = [(_e = t).uint64.bind(_e)];
            __esDecorate(null, null, _mode_decorators, { kind: "field", name: "mode", static: false, private: false, access: { has: obj => "mode" in obj, get: obj => obj.mode, set: (obj, value) => { obj.mode = value; } }, metadata: _metadata }, _mode_initializers, _mode_extraInitializers);
            __esDecorate(null, null, _nlinks_decorators, { kind: "field", name: "nlinks", static: false, private: false, access: { has: obj => "nlinks" in obj, get: obj => obj.nlinks, set: (obj, value) => { obj.nlinks = value; } }, metadata: _metadata }, _nlinks_initializers, _nlinks_extraInitializers);
            __esDecorate(null, null, _uid_decorators, { kind: "field", name: "uid", static: false, private: false, access: { has: obj => "uid" in obj, get: obj => obj.uid, set: (obj, value) => { obj.uid = value; } }, metadata: _metadata }, _uid_initializers, _uid_extraInitializers);
            __esDecorate(null, null, _gid_decorators, { kind: "field", name: "gid", static: false, private: false, access: { has: obj => "gid" in obj, get: obj => obj.gid, set: (obj, value) => { obj.gid = value; } }, metadata: _metadata }, _gid_initializers, _gid_extraInitializers);
            __esDecorate(null, null, _inode_decorators, { kind: "field", name: "inode", static: false, private: false, access: { has: obj => "inode" in obj, get: obj => obj.inode, set: (obj, value) => { obj.inode = value; } }, metadata: _metadata }, _inode_initializers, _inode_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            PXEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        mode = __runInitializers(this, _mode_initializers, void 0);
        nlinks = (__runInitializers(this, _mode_extraInitializers), __runInitializers(this, _nlinks_initializers, void 0));
        uid = (__runInitializers(this, _nlinks_extraInitializers), __runInitializers(this, _uid_initializers, void 0));
        gid = (__runInitializers(this, _uid_extraInitializers), __runInitializers(this, _gid_initializers, void 0));
        inode = (__runInitializers(this, _gid_extraInitializers), __runInitializers(this, _inode_initializers, void 0));
        constructor() {
            super(...arguments);
            __runInitializers(this, _inode_extraInitializers);
        }
    };
    return PXEntry = _classThis;
})();
export { PXEntry };
/**
 * RockRidge: Records POSIX device number.
 */
let PNEntry = (() => {
    var _a, _b;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _dev_high_decorators;
    let _dev_high_initializers = [];
    let _dev_high_extraInitializers = [];
    let _dev_low_decorators;
    let _dev_low_initializers = [];
    let _dev_low_extraInitializers = [];
    var PNEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _dev_high_decorators = [(_a = t).uint64.bind(_a)];
            _dev_low_decorators = [(_b = t).uint64.bind(_b)];
            __esDecorate(null, null, _dev_high_decorators, { kind: "field", name: "dev_high", static: false, private: false, access: { has: obj => "dev_high" in obj, get: obj => obj.dev_high, set: (obj, value) => { obj.dev_high = value; } }, metadata: _metadata }, _dev_high_initializers, _dev_high_extraInitializers);
            __esDecorate(null, null, _dev_low_decorators, { kind: "field", name: "dev_low", static: false, private: false, access: { has: obj => "dev_low" in obj, get: obj => obj.dev_low, set: (obj, value) => { obj.dev_low = value; } }, metadata: _metadata }, _dev_low_initializers, _dev_low_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            PNEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        dev_high = __runInitializers(this, _dev_high_initializers, void 0);
        dev_low = (__runInitializers(this, _dev_high_extraInitializers), __runInitializers(this, _dev_low_initializers, void 0));
        constructor() {
            super(...arguments);
            __runInitializers(this, _dev_low_extraInitializers);
        }
    };
    return PNEntry = _classThis;
})();
export { PNEntry };
/**
 * RockRidge: Records symbolic link
 */
let SLEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _flags_decorators;
    let _flags_initializers = [];
    let _flags_extraInitializers = [];
    var SLEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _flags_decorators = [(_a = t).uint8.bind(_a)];
            __esDecorate(null, null, _flags_decorators, { kind: "field", name: "flags", static: false, private: false, access: { has: obj => "flags" in obj, get: obj => obj.flags, set: (obj, value) => { obj.flags = value; } }, metadata: _metadata }, _flags_initializers, _flags_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            SLEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        flags = __runInitializers(this, _flags_initializers, void 0);
        get continueFlag() {
            return this.flags & 1;
        }
        get componentRecords() {
            const records = [];
            let i = 5;
            while (i < this.length) {
                const record = new SLComponentRecord(this.data.slice(i));
                records.push(record);
                i += record.length;
            }
            return records;
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _flags_extraInitializers);
        }
    };
    return SLEntry = _classThis;
})();
export { SLEntry };
export function constructSystemUseEntry(data) {
    const sue = new SystemUseEntry(data);
    switch (sue.signature) {
        case 17221 /* EntrySignature.CE */:
            return new CEEntry(data);
        case 20548 /* EntrySignature.PD */:
            return new PDEntry(data);
        case 21328 /* EntrySignature.SP */:
            return new SPEntry(data);
        case 21332 /* EntrySignature.ST */:
            return new STEntry(data);
        case 17746 /* EntrySignature.ER */:
            return new EREntry(data);
        case 17747 /* EntrySignature.ES */:
            return new ESEntry(data);
        case 20568 /* EntrySignature.PX */:
            return new PXEntry(data);
        case 20558 /* EntrySignature.PN */:
            return new PNEntry(data);
        case 21324 /* EntrySignature.SL */:
            return new SLEntry(data);
        case 20045 /* EntrySignature.NM */:
            return new NMEntry(data);
        case 17228 /* EntrySignature.CL */:
            return new CLEntry(data);
        case 20556 /* EntrySignature.PL */:
            return new PLEntry(data);
        case 21061 /* EntrySignature.RE */:
            return new REEntry(data);
        case 21574 /* EntrySignature.TF */:
            return new TFEntry(data);
        case 21318 /* EntrySignature.SF */:
            return new SFEntry(data);
        case 21074 /* EntrySignature.RR */:
            return new RREntry(data);
        default:
            return sue;
    }
}
export function constructSystemUseEntries(data, i, length, isoData) {
    // If the remaining allocated space following the last recorded System Use Entry in a System
    // Use field or Continuation Area is less than four bytes long, it cannot contain a System
    // Use Entry and shall be ignored
    length -= 4n;
    const entries = [];
    while (i < length) {
        const entry = constructSystemUseEntry(data.slice(i));
        const length = entry.length;
        if (!length) {
            // Invalid SU section; prevent infinite loop.
            return entries;
        }
        i += length;
        if (entry instanceof STEntry) {
            // ST indicates the end of entries.
            break;
        }
        entries.push(...(entry instanceof CEEntry ? entry.entries(isoData) : [entry]));
    }
    return entries;
}
/**
 * RockRidge: Records alternate file name
 */
let NMEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _flags_decorators;
    let _flags_initializers = [];
    let _flags_extraInitializers = [];
    var NMEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _flags_decorators = [(_a = t).uint8.bind(_a)];
            __esDecorate(null, null, _flags_decorators, { kind: "field", name: "flags", static: false, private: false, access: { has: obj => "flags" in obj, get: obj => obj.flags, set: (obj, value) => { obj.flags = value; } }, metadata: _metadata }, _flags_initializers, _flags_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            NMEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        flags = __runInitializers(this, _flags_initializers, void 0);
        name(getString) {
            return getString(this.data.slice(5, this.length));
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _flags_extraInitializers);
        }
    };
    return NMEntry = _classThis;
})();
export { NMEntry };
/**
 * RockRidge: Records child link
 */
let CLEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _childDirectoryLba_decorators;
    let _childDirectoryLba_initializers = [];
    let _childDirectoryLba_extraInitializers = [];
    var CLEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _childDirectoryLba_decorators = [(_a = t).uint32.bind(_a)];
            __esDecorate(null, null, _childDirectoryLba_decorators, { kind: "field", name: "childDirectoryLba", static: false, private: false, access: { has: obj => "childDirectoryLba" in obj, get: obj => obj.childDirectoryLba, set: (obj, value) => { obj.childDirectoryLba = value; } }, metadata: _metadata }, _childDirectoryLba_initializers, _childDirectoryLba_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            CLEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        childDirectoryLba = __runInitializers(this, _childDirectoryLba_initializers, void 0);
        constructor() {
            super(...arguments);
            __runInitializers(this, _childDirectoryLba_extraInitializers);
        }
    };
    return CLEntry = _classThis;
})();
export { CLEntry };
/**
 * RockRidge: Records parent link.
 */
let PLEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _parentDirectoryLba_decorators;
    let _parentDirectoryLba_initializers = [];
    let _parentDirectoryLba_extraInitializers = [];
    var PLEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _parentDirectoryLba_decorators = [(_a = t).uint32.bind(_a)];
            __esDecorate(null, null, _parentDirectoryLba_decorators, { kind: "field", name: "parentDirectoryLba", static: false, private: false, access: { has: obj => "parentDirectoryLba" in obj, get: obj => obj.parentDirectoryLba, set: (obj, value) => { obj.parentDirectoryLba = value; } }, metadata: _metadata }, _parentDirectoryLba_initializers, _parentDirectoryLba_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            PLEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        parentDirectoryLba = __runInitializers(this, _parentDirectoryLba_initializers, void 0);
        constructor() {
            super(...arguments);
            __runInitializers(this, _parentDirectoryLba_extraInitializers);
        }
    };
    return PLEntry = _classThis;
})();
export { PLEntry };
/**
 * RockRidge: Records relocated directory.
 */
let REEntry = (() => {
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    var REEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            REEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
    };
    return REEntry = _classThis;
})();
export { REEntry };
/**
 * RockRidge: Records file timestamps
 */
let TFEntry = (() => {
    var _a;
    let _classDecorators = [struct()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SystemUseEntry;
    let _flags_decorators;
    let _flags_initializers = [];
    let _flags_extraInitializers = [];
    var TFEntry = class extends _classSuper {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _flags_decorators = [(_a = t).uint8.bind(_a)];
            __esDecorate(null, null, _flags_decorators, { kind: "field", name: "flags", static: false, private: false, access: { has: obj => "flags" in obj, get: obj => obj.flags, set: (obj, value) => { obj.flags = value; } }, metadata: _metadata }, _flags_initializers, _flags_extraInitializers);
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            TFEntry = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        flags = __runInitializers(this, _flags_initializers, void 0);
        _getDate(kind) {
            if (!(this.flags & kind)) {
                return;
            }
            // Count the number of flags set up to but not including `kind`
            let index = 0;
            for (let i = 0; i < kind - 1; i++) {
                index += this.flags & (1 << i) ? 1 : 0;
            }
            const _Date = this.flags & 128 /* TFFlag.LONG_FORM */ ? LongFormDate : ShortFormDate;
            const offset = 5 + index * sizeof(_Date);
            const date = new _Date();
            deserialize(date, this.data.slice(offset, offset + sizeof(_Date)));
            return date.date;
        }
        get creation() {
            return this._getDate(1 /* TFFlag.CREATION */);
        }
        get modify() {
            return this._getDate(2 /* TFFlag.MODIFY */);
        }
        get access() {
            return this._getDate(4 /* TFFlag.ACCESS */);
        }
        get backup() {
            return this._getDate(16 /* TFFlag.BACKUP */);
        }
        get expiration() {
            return this._getDate(32 /* TFFlag.EXPIRATION */);
        }
        get effective() {
            return this._getDate(64 /* TFFlag.EFFECTIVE */);
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _flags_extraInitializers);
        }
    };
    return TFEntry = _classThis;
})();
export { TFEntry };
/**
 * RockRidge: File data in sparse format.
 */
let SFEntry = (() => {
    var _a, _b, _c;
    let _classSuper = SystemUseEntry;
    let _virtualSizeHigh_decorators;
    let _virtualSizeHigh_initializers = [];
    let _virtualSizeHigh_extraInitializers = [];
    let _virtualSizeLow_decorators;
    let _virtualSizeLow_initializers = [];
    let _virtualSizeLow_extraInitializers = [];
    let _tableDepth_decorators;
    let _tableDepth_initializers = [];
    let _tableDepth_extraInitializers = [];
    return class SFEntry extends _classSuper {
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _virtualSizeHigh_decorators = [(_a = t).uint64.bind(_a)];
            _virtualSizeLow_decorators = [(_b = t).uint64.bind(_b)];
            _tableDepth_decorators = [(_c = t).uint8.bind(_c)];
            __esDecorate(null, null, _virtualSizeHigh_decorators, { kind: "field", name: "virtualSizeHigh", static: false, private: false, access: { has: obj => "virtualSizeHigh" in obj, get: obj => obj.virtualSizeHigh, set: (obj, value) => { obj.virtualSizeHigh = value; } }, metadata: _metadata }, _virtualSizeHigh_initializers, _virtualSizeHigh_extraInitializers);
            __esDecorate(null, null, _virtualSizeLow_decorators, { kind: "field", name: "virtualSizeLow", static: false, private: false, access: { has: obj => "virtualSizeLow" in obj, get: obj => obj.virtualSizeLow, set: (obj, value) => { obj.virtualSizeLow = value; } }, metadata: _metadata }, _virtualSizeLow_initializers, _virtualSizeLow_extraInitializers);
            __esDecorate(null, null, _tableDepth_decorators, { kind: "field", name: "tableDepth", static: false, private: false, access: { has: obj => "tableDepth" in obj, get: obj => obj.tableDepth, set: (obj, value) => { obj.tableDepth = value; } }, metadata: _metadata }, _tableDepth_initializers, _tableDepth_extraInitializers);
            if (_metadata) Object.defineProperty(this, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        }
        virtualSizeHigh = __runInitializers(this, _virtualSizeHigh_initializers, void 0);
        virtualSizeLow = (__runInitializers(this, _virtualSizeHigh_extraInitializers), __runInitializers(this, _virtualSizeLow_initializers, void 0));
        tableDepth = (__runInitializers(this, _virtualSizeLow_extraInitializers), __runInitializers(this, _tableDepth_initializers, void 0));
        constructor() {
            super(...arguments);
            __runInitializers(this, _tableDepth_extraInitializers);
        }
    };
})();
export { SFEntry };
//# sourceMappingURL=entries.js.map